import * as React from "react";
import { SVGProps, memo } from "react";
const SvgCertified14Px = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.678 6.07a1.51 1.51 0 0 0-1.006-2.428 1.511 1.511 0 0 1-1.314-1.315 1.51 1.51 0 0 0-2.429-1.006 1.505 1.505 0 0 1-1.858 0 1.51 1.51 0 0 0-2.429 1.006 1.511 1.511 0 0 1-1.314 1.315A1.51 1.51 0 0 0 1.322 6.07a1.51 1.51 0 0 1 0 1.86 1.51 1.51 0 0 0 1.006 2.428 1.51 1.51 0 0 1 1.314 1.315 1.51 1.51 0 0 0 2.429 1.005 1.507 1.507 0 0 1 1.858 0 1.51 1.51 0 0 0 2.429-1.005 1.51 1.51 0 0 1 1.314-1.315 1.51 1.51 0 0 0 1.006-2.428 1.51 1.51 0 0 1 0-1.86Z"
      fill="#008057"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m9.347 4.195.875.485-3.154 5.7a.5.5 0 0 1-.596.23l-.083-.036a.505.505 0 0 1-.077-.052.436.436 0 0 1-.094-.072l-2.48-2.456.708-.707 2.06 2.041 2.841-5.133Z"
      fill="#FAFAFA"
    />
  </svg>
);
const Memo = memo(SvgCertified14Px);
export default Memo;
